@if (component) {
<div [ngClass]="component.section_width || ''">
    <div [ngClass]="[component.column_align || '']">
        @switch (component.type) {
        @default {
        <span [ngClass]="'w-' + component.content_width">
            <span class="w-12 text"
                  [ngClass]="[component.color || '', component.align || '']"
                  *iCms="'text' of component; content: 'html'; tag: component.tag">
            </span>
        </span>
        }
        @case ('button') {
        <href [link]="component.cta_link">
            <button [ngClass]="[component.button_class || '']">
                <span class="button__body"
                      *iCms="'cta_label' of component">
                </span>
            </button>
        </href>
        }
        }
    </div>
</div>
}